import React from "react";

import { Container, StyledFillEmailIcon } from "./styles";

export const ArticleThemeSignUpButtonDisplay: React.FunctionComponent = () => (
  <Container>
    <StyledFillEmailIcon />
    GET OUR NEWSLETTER
  </Container>
);

ArticleThemeSignUpButtonDisplay.displayName = "ArticleThemeSignUpButtonDisplay";
